import moment from "moment";
import React, { useEffect, useState } from "react";
import { Space } from "antd";
import { type HistoryCreditLimitEntity } from "../../../entities/CreditLimitEntity";
import { Texts } from "../../GeneralSettingPage/orderTimeFrame/OrderPeriod.styles";
import StatusBadge from "../../../components/Badge/StatusBadge";
import Text from "../../../components/Text/Text";
import TablePagination from "../../../components/Table/TablePagination";
import { icon } from "../../../resource";
import { historyTempCreditLimit } from "../../../datasource/CreditLimitDatasource";
import { normalizeStatus, STATUS_CREDIT } from "../../../definitions/creditStatus";
import { getHistoryOrder } from "../../../datasource/OrderDatasourc";

function HistoryCredit({
  dataHis,
  callBackCount,
}: {
  dataHis: HistoryCreditLimitEntity[];
  callBackCount?: (count: number) => void;
}) {
  const [loading, setLoading] = useState(false);
  const creditTabs = localStorage.getItem("creditTabs");

  const columns: any = [
    {
      title: "วันที่อัปเดต",
      dataIndex: creditTabs === "ORDER" ? "updateAt" : "createdAt",
      key: creditTabs === "ORDER" ? "updateAt" : "createdAt",
      width: 120,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts size='16'>{moment(value).format("DD/MM/YYYY, HH:mm")}</Texts>
            </>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: creditTabs === "ORDER" ? "action" : "afterValue",
      key: creditTabs === "ORDER" ? "action" : "afterValue",
      width: 90,
      render: (value: any, row: any, index: number) => {
        const normalizedStatus = normalizeStatus(value);
        const meta = STATUS_CREDIT[normalizedStatus] || {};
        return {
          children: (
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <StatusBadge key={index} label={meta.label || "-"} bgColor={meta.color || "gray"} />
              {creditTabs === "CREDIT" && value === "APPROVED" && (
                <StatusBadge
                  key={index + 1}
                  label={STATUS_CREDIT[String(row.isActive)].label}
                  bgColor={STATUS_CREDIT[String(row.isActive)].color}
                />
              )}
            </div>
          ),
        };
      },
    },
    {
      title: "กิจกรรม",
      dataIndex: "action",
      key: "action",
      width: 200,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Space direction='vertical' size={1}>
              <Texts size='16'>
                {creditTabs === "ORDER"
                  ? value === "PENDING"
                    ? "-"
                    : value === "APPROVE"
                      ? `อนุมัติ${row.approveType === "CREDIT" ? "วงเงิน" : "ใบสั่งขาย"}`
                      : value === "REJECT"
                        ? `ไม่อนุมัติ${row.approveType === "CREDIT" ? "วงเงิน" : "ใบสั่งขาย"}`
                        : "-"
                  : value || "-"}
              </Texts>
            </Space>
          ),
        };
      },
    },
    {
      title: "ผู้ดำเนินการ",
      dataIndex: creditTabs === "ORDER" ? "updateBy" : "createdBy",
      key: creditTabs === "ORDER" ? "updateBy" : "createdBy",
      width: 160,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Space direction='vertical' size={1}>
              <Texts fontWeight={700} size='16px'>
                {value}
              </Texts>
              <Texts size='14px'>{row.role}</Texts>
            </Space>
          ),
        };
      },
    },
    {
      title: "เหตุผล",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (value: any) => {
        if (!value) return <Texts>-</Texts>;

        let parsedReason: any = value;
        if (typeof value === "string" && value.startsWith("{")) {
          try {
            parsedReason = JSON.parse(value);
          } catch {
            parsedReason = value;
          }
        }

        if (typeof parsedReason === "string") {
          return parsedReason.trim() ? (
            <div>
              <Text fontFamily='Sarabun' fontWeight={700} fontSize={16}>
                เหตุผลสำหรับการแก้ไข
              </Text>
              <Texts size='16'>{parsedReason}</Texts>
            </div>
          ) : (
            <Texts>-</Texts>
          );
        }

        const { remarkReject, reason } = parsedReason;
        return (
          <>
            {reason?.trim() && (
              <div style={{ marginBottom: remarkReject ? 14 : 0 }}>
                <Text fontFamily='Sarabun' fontWeight={700} fontSize={16}>
                  เหตุผลสำหรับการแก้ไข
                </Text>
                <Texts size='16'>{reason}</Texts>
              </div>
            )}
            {remarkReject?.trim() && (
              <>
                <Text fontFamily='Sarabun' fontWeight={700} fontSize={16}>
                  เหตุผลสำหรับสถานะ
                </Text>
                <Texts size='16'>{remarkReject}</Texts>
              </>
            )}
            {!reason?.trim() && !remarkReject?.trim() && <Texts>-</Texts>}
          </>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 4 }}>
      <TablePagination
        vertical='top'
        isLoading={loading}
        columns={columns}
        data={dataHis || []}
        locale={{
          emptyText: (
            <div
              style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 24,
                minHeight: 350,
              }}
            >
              <img
                src={icon.emptyHistoryPoint}
                style={{
                  width: 80,
                  height: 90,
                }}
                alt='empty_table'
              />
              <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                ไม่มีรายการประวัติ
              </Text>
            </div>
          ),
        }}
      />
    </div>
  );
}

export default HistoryCredit;
